import { Document, SectionType } from "docx";
import { getAppendix1Paragraphs } from "../sections/appendix1";
import { getAppendix2Paragraphs } from "../sections/appendix2";
import { getBankChargesParagraphs } from "../sections/bankCharges";
import { getCapitalisedRdeParagraphs } from "../sections/capitalisedRde";
import { getConsentingNonConsentingCompaniesParagraphs } from "../sections/consentingnonConsentingCompanies";
import { getCoverPage } from "../sections/coverPage";
import { getDerivativesParagraphs } from "../sections/derivatives";
import { getDisallowanceParagraphs } from "../sections/disallowance";
import { getDoubleTaxReliefParagraphs } from "../sections/dtr";
import { getElectionsParagraphs } from "../sections/elections";
import { getFilingDeadlineParagraphs } from "../sections/filingDeadline";
import { getFooter } from "../sections/footer";
import { getHeader } from "../sections/header";
import { getIndentificationOfWorldwideGroupParagraphs } from "../sections/identification";
import { getLeasesParagraphs } from "../sections/leases";
import { getNameOfReturnParagraphs } from "../sections/natureReturn";
import { getNoDisallowanceParagraphs } from "../sections/noDisallowance";
import { getPoaParagraphs } from "../sections/poa";
import { getRdecParagraphs } from "../sections/rdec";
import { getReportingCompanyParagraphs } from "../sections/reportingCompany";
import { getScopeAndExclusionsParagraphs } from "../sections/scopeAndExclusions";
import { getSummaryParagraphs } from "../sections/summary";
import { getTableOfContents } from "../sections/tableOfContents";
import { getDocumentData, getExtraFooter } from "./WordExportUtils";
import { numberingStyle, tableOfContentsStyle } from "./styling";

export async function createWordReport(isClientFacing = true) {
  const documentData = getDocumentData(isClientFacing);

  const header = await getHeader(isClientFacing);
  const footer = getFooter(undefined, isClientFacing);

  const reportingCompanyFooter = getExtraFooter(
    "1",
    " 6 months for appointments made before 12 February 2019",
  );
  const fullReportingCompanyFooter = getFooter(
    reportingCompanyFooter,
    isClientFacing,
  );

  const capitalisedRdeFooter = getExtraFooter(
    "2",
    ' As amended by the "The Research and Development (Prescribed Activities) Regulations 2004" (SI 2004/712 - aka the "BEIS Guidelines")',
  );
  const fullCapitalisedRdeFooter = getFooter(
    capitalisedRdeFooter,
    isClientFacing,
  );

  const doc = new Document({
    creator: "PwC CIR Compliance Manager",
    description: "CIR - Report",
    title: "Generated Document",
    features: {
      updateFields: true,
    },
    sections: [
      {
        ...header,
        ...footer,
        children: [...getCoverPage(documentData)],
      },
      {
        properties: { type: SectionType.CONTINUOUS },
        children: [...getTableOfContents()],
      },
      {
        properties: { type: SectionType.CONTINUOUS },
        children: [...getScopeAndExclusionsParagraphs(documentData)],
      },
      {
        properties: { type: SectionType.CONTINUOUS },
        children: [...getSummaryParagraphs(documentData)],
      },
      {
        properties: { type: SectionType.CONTINUOUS },
        children: [
          ...getIndentificationOfWorldwideGroupParagraphs(documentData),
        ],
      },
      {
        properties: { type: SectionType.CONTINUOUS },
        children: [...getPoaParagraphs(documentData)],
      },
      {
        properties: { type: SectionType.CONTINUOUS },
        ...fullReportingCompanyFooter,
        children: [...getReportingCompanyParagraphs(documentData)],
      },
      {
        properties: { type: SectionType.CONTINUOUS },
        ...footer,
        children: [
          ...getConsentingNonConsentingCompaniesParagraphs(documentData),
        ],
      },
      {
        properties: { type: SectionType.CONTINUOUS },
        children: [...getFilingDeadlineParagraphs(documentData)],
      },
      {
        properties: { type: SectionType.CONTINUOUS },
        children: [...getDisallowanceParagraphs(documentData)],
      },
      {
        properties: { type: SectionType.CONTINUOUS },
        children: [...getNoDisallowanceParagraphs(documentData)],
      },
      {
        properties: { type: SectionType.CONTINUOUS },
        children: [...getNameOfReturnParagraphs(documentData)],
      },
      {
        properties: { type: SectionType.CONTINUOUS },
        children: [...getElectionsParagraphs(documentData)],
      },
      {
        properties: { type: SectionType.CONTINUOUS },
        ...fullCapitalisedRdeFooter,
        children: [...getRdecParagraphs(documentData)],
      },
      {
        properties: { type: SectionType.CONTINUOUS },
        ...footer,
        children: [...getCapitalisedRdeParagraphs(documentData)],
      },
      {
        properties: { type: SectionType.CONTINUOUS },
        children: [...getDoubleTaxReliefParagraphs(documentData)],
      },
      {
        properties: { type: SectionType.CONTINUOUS },
        children: [...getDerivativesParagraphs(documentData)],
      },
      {
        properties: { type: SectionType.CONTINUOUS },
        children: [...getLeasesParagraphs(documentData)],
      },
      {
        properties: { type: SectionType.CONTINUOUS },
        children: [...getBankChargesParagraphs()],
      },
      {
        properties: { type: SectionType.CONTINUOUS },
        children: [...getAppendix1Paragraphs(documentData)],
      },
      {
        properties: { type: SectionType.CONTINUOUS },
        children: [...getAppendix2Paragraphs()],
      },
    ],
    numbering: {
      config: [
        {
          reference: "numbering-1",
          levels: [numberingStyle],
        },
        {
          reference: "numbering-2",
          levels: [numberingStyle],
        },
      ],
    },
    styles: {
      paragraphStyles: [tableOfContentsStyle],
    },
  });

  return doc;
}
